var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPatientSyncing = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49.045,
    height: 39.236,
    viewBox: "0 0 49.045 39.236",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-times-solid",
    d: "M17.166,19.618A9.809,9.809,0,1,0,7.357,9.809,9.808,9.808,0,0,0,17.166,19.618Zm6.866,2.452h-1.28a13.34,13.34,0,0,1-11.173,0H10.3A10.3,10.3,0,0,0,0,32.369v3.188a3.679,3.679,0,0,0,3.678,3.678H30.653a3.679,3.679,0,0,0,3.678-3.678V32.369A10.3,10.3,0,0,0,24.032,22.07Z",
    transform: "translate(0 3.965)",
    fill: "#008c98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "sync-solid",
    d: "M20.3.579l.184,3.812A11.415,11.415,0,0,0,.566,9.664a.553.553,0,0,0,.544.653H3.369a.553.553,0,0,0,.538-.427,8.1,8.1,0,0,1,14.6-2.623l-4.673-.224a.553.553,0,0,0-.579.553V9.781a.553.553,0,0,0,.553.553H23.03a.553.553,0,0,0,.553-.553V.553A.553.553,0,0,0,23.03,0H20.848A.553.553,0,0,0,20.3.579ZM11.784,19.9a8.089,8.089,0,0,1-6.725-3.583l4.689.224a.553.553,0,0,0,.579-.553V13.8a.553.553,0,0,0-.553-.553H.553A.553.553,0,0,0,0,13.8V23.03a.553.553,0,0,0,.553.553H2.734A.553.553,0,0,0,3.286,23L3.1,19.2A11.414,11.414,0,0,0,23,13.918a.553.553,0,0,0-.544-.653H20.2a.553.553,0,0,0-.538.427A8.1,8.1,0,0,1,11.784,19.9Z",
    transform: "translate(34.331)",
    fill: "#008c98"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPatientSyncing, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/patient-syncing.d0823362.svg";
export { ForwardRef as ReactComponent };